export default '0.3.47';

